import { ShowDates } from "components/showdatepicker/models";
import React from "react";
import { getShowDateTimeDisplay } from "shared/utils/showDateTimeDisplay";
import { timeDifferenceStringsFromResx } from "utilities/momentutils";
import ShowTime from "./ShowTime";
import { mapAppointmentDateTimeToShowDates } from "shared/utils/fieldsHelper/showFields";

interface Props {
  dateTime: server.dto.AppointmentDateTime
}

const ShowDateTime = (props: Props) => {
  const display = getShowDateTimeDisplay(mapAppointmentDateTimeToShowDates(props.dateTime), {
    untilAndIncludingAbbreviated: RESX.DateTime.UntilAndIncludingAbbreviated,
    inTheNightOfXY: RESX.DateTime.InTheNightOfXY,
    ...timeDifferenceStringsFromResx()
  });

  return <>
    <div>{display.dateText}</div>
    {display.inTheNightOfText ? <div>{display.inTheNightOfText}</div> : null}
    <div>
      <ShowTime dateTime={props.dateTime} />
    </div>
  </>;
};

export const ShowDateTimeShowInfo = ({ showDates }: { showDates: ShowDates }) => {
  return <ShowDateTime dateTime={{
    startDisplay: showDates.startDisplayDate.toDate(),
    endDisplay: showDates.endDisplayDate.toDate(),
    mode: showDates.mode,
    customFallbackTime: showDates.timeOfPerformance
  }} />;
}

export default ShowDateTime;
